export default __webpack_public_path__ + "../images/rectangle-white-2.png";